import { useForm } from "react-hook-form";
import { FormContainer, TextInput, SelectInput } from "../../shared";
import useGlobalMutation from "../../../hooks/useGlobalMutation";
import { UPDATE_BASIC_LOGIN_USER } from "./query";
import { RegexPattern, updateCache } from "../../../utils";

const UpdateBasicLoginUser = ({ data }) => {
    const { id, firstName, lastName, email, phone, gender, username } = data;

    const defaultValues = {
        firstName,
        lastName,
        email,
        phone,
        gender,
        username,
    };
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues,
    });

    const { submitMutation, loading } = useGlobalMutation(
        UPDATE_BASIC_LOGIN_USER,
        (cache, result) => {
            const basicLoginUser = result?.data?.customUpdateBasicLoginUser.basicLoginUser;

            updateCache(cache, id, basicLoginUser, "BasicLoginUser");
        }
    );

    const submitAction = handleSubmit(async (data) => {
        const { firstName, lastName, email, phone, gender, username } = data;

        const variables = {
            id,
            basicLoginUserInput: {
                firstName,
                lastName,
                email,
                phone,
                gender,
                username: username.trim(),
            },
        };

        await submitMutation(
            variables,
            "customUpdateBasicLoginUser.basicLoginUser",
            "User updated successfully"
        );
    });

    return (
        <FormContainer submitAction={submitAction} loading={loading} submitBtnSm>
            <h5 className="mb-4">Update Basic Login User</h5>
            <div className="row">
                <div className="col-md-6">
                    <TextInput
                        id="firstName"
                        labelText="First Name"
                        {...register("firstName", {
                            required: true,
                            pattern: RegexPattern.name,
                        })}
                        isInvalid={!!errors.firstName}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        id="lastName"
                        labelText="Last Name"
                        {...register("lastName", {
                            required: true,
                            pattern: RegexPattern.name,
                        })}
                        isInvalid={!!errors.lastName}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        id="email"
                        type="email"
                        labelText="Email"
                        {...register("email", {
                            required: true,
                            pattern: RegexPattern.email,
                        })}
                        isInvalid={!!errors.email}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        id="phone"
                        type="number"
                        labelText="Phone"
                        {...register("phone", {
                            pattern: RegexPattern.number,
                        })}
                        isInvalid={!!errors.phone}
                    />
                </div>

                <div className="col-md-6">
                    <SelectInput
                        id="gender"
                        labelText="Gender"
                        {...register("gender", {})}
                        options={[
                            { id: "M", name: "Male" },
                            { id: "F", name: "Female" },
                        ]}
                        isInvalid={!!errors.gender}
                    />
                </div>

                <div className="col-md-6">
                    <TextInput
                        id="username"
                        type="username"
                        labelText="Username"
                        {...register("username", {
                            required: true,
                        })}
                        isInvalid={!!errors.username}
                        required
                    />
                </div>
            </div>
        </FormContainer>
    );
};

export default UpdateBasicLoginUser;
